var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
import Helper from '@ember/component/helper';
import { dropTask, timeout } from 'ember-concurrency';
import { ClassNameSet, splitClassNames, waitForTransition } from '../../utils/transition';
export let AppliedClassNamesManager = (_class = class AppliedClassNamesManager extends Helper {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "appliedClassNames", new ClassNameSet());
    /**
     * Tracks the last `this.show` value, so we can determine if we need to initiate a transition as part of `compute`
     * being executed
     *
     * This is because `compute` is sometimes called because an argument changed (and we want to kick off a new
     * transition) and sometimes it's called to update the produced value during an existing transition (and we *do
     * not* want to kick off a new transition)
     */
    _defineProperty(this, "previousShowValue", false);
  }
  /** @type {import('../../components/transition').default} */
  get transition() {
    return this.args[0];
  }

  /**
   * The `Transition` component's `@show` value
   *
   * Represents the desired visibility of the component.
   *
   * @type {boolean}
   */
  get show() {
    return this.args[1];
  }
  get enterClasses() {
    return splitClassNames(this.transition.args.enter);
  }
  get enterFromClasses() {
    return splitClassNames(this.transition.args.enterFrom);
  }
  get enterToClasses() {
    return splitClassNames(this.transition.args.enterTo);
  }
  get enteredClasses() {
    return splitClassNames(this.transition.args.entered);
  }
  get leaveClasses() {
    return splitClassNames(this.transition.args.leave);
  }
  get leaveFromClasses() {
    return splitClassNames(this.transition.args.leaveFrom);
  }
  get leaveToClasses() {
    return splitClassNames(this.transition.args.leaveTo);
  }
  *setTransitionClassesTask(base, from, to, entered) {
    this.appliedClassNames.delete(...entered);
    this.appliedClassNames.add(...base, ...from);
    this.recompute();

    // Wait for the next tick
    yield timeout(0);
    this.appliedClassNames.delete(...from);
    this.appliedClassNames.add(...to);
    this.recompute();
    yield waitForTransition(this.transition.ownDomNode);
    this.appliedClassNames.delete(...to, ...base);
    this.appliedClassNames.add(...entered);
    this.recompute();
  }
  *transitionToShow() {
    this.transition.args.beforeEnter?.();
    yield this.setTransitionClassesTask.perform(this.enterClasses, this.enterFromClasses, this.enterToClasses, this.enteredClasses);
    this.transition.args.afterEnter?.();
  }
  *transitionToHide() {
    this.transition.args.beforeLeave?.();
    yield this.setTransitionClassesTask.perform(this.leaveClasses, this.leaveFromClasses, this.leaveToClasses, this.enteredClasses);
    this.transition.args.afterLeave?.();
  }
  shouldTransition() {
    return this.show !== this.previousShowValue;
  }
  compute(positionalArgs) {
    // Make sure we have a reference to the args
    this.args = positionalArgs;
    const skip = this.transition.initialRender && !this.transition.args.appear;
    if (!skip && this.shouldTransition()) {
      if (this.show) {
        this.transitionToShow.perform();
      }
      if (!this.show) {
        this.transitionToHide.perform();
      }
    }
    this.previousShowValue = this.show;
    return this.appliedClassNames.toString();
  }
}, (_applyDecoratedDescriptor(_class.prototype, "setTransitionClassesTask", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "setTransitionClassesTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transitionToShow", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToShow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transitionToHide", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToHide"), _class.prototype)), _class);